import React from 'react';
import { useProfileData } from '../../hooks/useProfileData';
import { useListProjectsQuery } from '../../api/project';
import { Link } from 'react-router-dom';

export default function OnboardingSteps() {
    const { isProfileComplete } = useProfileData();
    const { data: projects } = useListProjectsQuery({});
    
    // Check if there are any projects
    const hasProjects = projects && projects.length > 0;
    
    // Check if any project has images by looking at the projects data
    // This assumes the projects API returns image count or image data
    const hasImages = projects && projects.some((project: any) => 
        project.image_count > 0 || (project.images && project.images.length > 0)
    );
    
    return <ul className="onboarding-steps steps steps-vertical">
        <li className="step step-primary onboarding-step-register">Register and account setup</li>
        <li className={`step onboarding-step-profile ${isProfileComplete ? 'step-primary' : ''}`}>
            {isProfileComplete ? (
                <span className="profile-complete-text">Complete your profile</span>
            ) : (
                <Link to="/profile" className="profile-link text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 underline">
                    Complete your profile
                </Link>
            )}
        </li>
        <li className={`step onboarding-step-project ${hasProjects ? 'step-primary' : ''}`}>
            {hasProjects ? (
                <span className="project-complete-text">Create your first project</span>
            ) : (
                <Link to="/projects" className="project-link text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 underline">
                    Create your first project
                </Link>
            )}
        </li>
        <li className={`step onboarding-step-image ${hasImages ? 'step-primary' : ''}`}>
            {hasImages ? (
                <span className="image-complete-text">Upload your first image</span>
            ) : (
                <Link to="/projects" className="image-link text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 underline">
                    Upload your first image
                </Link>
            )}
        </li>
    </ul>
}